<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-row type="flex" class="row-bg">
          <el-col :span="23">
            <span class="table-title">Indicadores</span>
          </el-col>
          <el-col :span="1"  class="mr-2">
            <router-link to="/indicador/sort">
              <el-button type="warning" icon="el-icon-sort"></el-button>
            </router-link>
          </el-col>
          <el-col :span="1">
            <router-link to="/indicador/create">
              <el-button type="primary" icon="el-icon-plus"></el-button>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <div class="row" v-loading="loading">
        <div class="col">
          <data-tables :data="list" :table-props="tableProps">
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label" sortable="custom">
            </el-table-column>

            <el-table-column label="Superior" width="230">
              <template slot-scope="scope">
                  {{ scope.row.parent === null ? scope.row.parent_id : scope.row.parent.nome }}
              </template>
            </el-table-column>

            <el-table-column label="Unidade" width="80">
              <template slot-scope="scope">
                {{ scope.row.unidade.nome}}
              </template>
            </el-table-column>
            <el-table-column label="R" width="80">
              <template slot-scope="scope">
                   <i :class="scope.row.requisito_id === 1 ? 'icon-arrow-up-circle' : 'icon-arrow-down-circle'"></i>
              </template>
            </el-table-column>



            <el-table-column label="Ações" min-width="100px">
              <template slot-scope="scope">
                <el-dropdown>
                  <el-button size="mini" type="primary">
                    Ações<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="visualizar(scope.row.id)">Visualizar</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </data-tables>
        </div>

      </div>
    </el-card>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'indicador-index',
    data() {
      return {
        loading: false,
        titles: [{prop: 'id', label: '#'},
          {prop: 'nome', label: 'Nome'},
          {prop: 'formula', label: 'Formula'},
          {prop: 'formula_macro', label: 'Macro'},
          ],
        tableProps: {
          border: false,
          stripe: true
        }
      }
    },
    computed: {
      ...mapState('Indicador', ['list'])
    },
    methods: {
      ...mapActions('Indicador', ['setList']),
      async load() {
        this.loading = true
        await this.setList()
        this.loading = false
      },
      visualizar(id) {
        this.$router.push({name: 'indicador.show', params: {id}})
      }
    },
    mounted() {
      this.load();
    }
  }
</script>

<style scoped>
  .table-title {
    font-size: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/features/Indicador/index.vue